import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";
import * as APIS from '../utils/service.js'

import consts from '../libs/consts';
import InputFileDrag from '../components/InputFileDrag';
import Button from '../components/Button';
import Radio from "../components/Radio";
import Modal from "../components/Modal.js";
import { loadImage } from "../utils/utils.js";

/**
 * 고해상도 이미지 만들기
 */
export default function Menu3() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [modal, setModal] = useState(consts.defaultModalValue)

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);

    const [file, setFile] = useState(null);

    const [radio1, setRadio1] = useState(1);
    const [radio2, setRadio2] = useState(1);

    const [share, setShare] = useState(false);

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    const makeImageFunc = () => {
        console.log("makeImageFunc!!")

        let sendData = {
            photo: "",
            multiple: 0,
            qualituy: 0,
            share: !share
        }
        if (!file) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_photo" })
            })
            return;
        }

        sendData.photo = file
        sendData.multiple = radio1
        sendData.qualituy = radio2

        console.log(sendData)

        APIS.post("/aiImage/resolution", sendData).then(({ data }) => {
            if (data) console.log("/aiImage/avatar:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            console.log(data, getLang({ key: data.msgkey }));
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const defaultSetOption = (configData) => {
        let error = false

        if ("option_selector_multiple" in configData) {
            setRadio1(configData.option_selector_multiple[0].idx)
        } else {
            error = true
        }

        if ("option_selector_quality" in configData) {
            setRadio2(configData.option_selector_quality[0].idx)
        } else {
            error = true
        }

        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.photoFile) {
            let imageData = await loadImage(consts.imgUrl + artData?.photoFile)
            setFile(imageData)
        }

        if (artData?.multipleOption) {
            let data = configData?.option_selector_multiple?.find(v => v.value == artData?.multipleOption)
            if (data) {
                setRadio1(data.idx)
            }
        }
        if (artData?.qualityOption) {
            let data = configData?.option_selector_quality?.find(v => v.value == artData?.qualityOption)
            if (data) {
                setRadio2(data.idx)
            }
        }
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    useEffect(() => {
        configDataFunc();
    }, [])

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 3 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 3 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 3 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 3 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_row" /></p>
                                <p className="body1"><LangText id="info_upload_row" /></p>
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            value={file}
                            setValue={setFile}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_option_set" /></p>
                                <p className="body1"><LangText id="info_option_set" /></p>
                            </div>
                        </div>
                        <div className="border_box">
                            <p className="body1 color-black">
                                <LangText id="text_option_resolution" />
                            </p>
                            <Radio
                                className="mt-12"
                                border={false}
                                value={radio1}
                                setValue={setRadio1}
                                options={config?.option_selector_multiple?.map((v) => {
                                    return { label: getLang({ key: v?.title_key }), value: v.idx }
                                })} />
                            <hr className="mt-24" />
                            <p className="body1 mt-24 color-black">
                                <LangText id="text_option_quality" />
                            </p>
                            <Radio
                                className="mt-12"
                                border={false}
                                value={radio2}
                                setValue={setRadio2}
                                options={config?.option_selector_quality?.map((v) => {
                                    return { label: getLang({ key: v?.title_key }), value: v.idx }
                                })} />
                        </div>
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_image", replace: { key: "{0}", val: getMenu({ idx: 3 })?.point } })}
                        round
                        onClick={() => {
                            makeImageFunc();
                        }}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        // checked={false}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
